import React, { useEffect } from "react";
import G1 from "../assests/G1.png";
import G2 from "../assests/G2.png";
import Galaxy1 from "../assests/Galaxy1.png";
import Ideal1 from "../assests/Ideal1.png";
import AOS from "aos";
import "aos/dist/aos.css";

const projects = [
  {
    name: "Gold Land Garden I",
    image: G1,
    href: "https://www.facebook.com/profile.php?id=100063768623029",
  },
  {
    name: "Gold Land Garden II",
    image: G2,
    href: "https://www.facebook.com/profile.php?id=61579787109650",
  },
  {
    name: "Galaxy Avenue",
    image: Galaxy1,
    href: "https://www.facebook.com/profile.php?id=100088725812658",
  },
  {
    name: "Ideal Avenue",
    image: Ideal1,
    href: "https://www.facebook.com/idealavenue51480/",
  },
];

export default function ChooseUs() {
  useEffect(() => {
    AOS.init({
      duration: 900,
      easing: "ease-out",
      delay: 40,
    });
  }, []);

  return (
    <div className="chooseUsMain" id="projects">
      <div className="projectsInner">
        <h1 className="servicesHeadingText">Our Project</h1>
        <p className="servicesParaText projectsIntro">
          Our attractive development, including Galaxy Avenue, Ideal Avenue,
          GLG-I, and GLG-II, provides contemporary, lavish living right in the
          center of the city.
        </p>

        <div className="projectsRow">
          {projects.map((project, index) => (
            <a
              key={project.name}
              href={project.href}
              target="_blank"
              rel="noopener noreferrer"
              className="projectLogoLink"
              data-aos="zoom-in"
              data-aos-delay={index * 120}
              aria-label={project.name}
            >
              <img src={project.image} alt={project.name} className="projectLogo" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
